import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import { toast } from "react-toastify";
import { useDisclosure } from "@chakra-ui/hooks";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Card from "components/card";
import { createCustomer, getCustomerAcquisitionYears } from "interfaces/customer";
import { createDeliveryTour, getDeliveryTours } from "interfaces/deliveryTour";
import InputField from "components/fields/InputField";
import InputTagField from "components/fields/InputTagField";
import SearchSelector from "components/fields/SearchSelector";
import { isFormErrored, isValidEmail, isValidPhoneNumber } from "utils/verification";
import GoBack from "components/actions/GoBack";
import { getMyInfo, updateMyInfo } from "interfaces/user";
import Switch from "components/switch";


const CreateProspect = () => {
    const navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [newCustomer, setNewCustomer] = useState<any>({
        status: 'prospect'
    });
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [deliveryTours, setDeliveryTours] = useState<any>([]);
	const [user, setUser] = useState<any>(null);
	const [acquisitionYears, setAcquisitionYears] = useState<string[]>([]);

    const initUser = async () => {
        const res = await getMyInfo();
        if (res?.data) setUser(res.data);
    };

    const initAcquisitionYears = async () => {
        const res = await getCustomerAcquisitionYears();
        if (res) setAcquisitionYears(res);
    };

    const addNewTag = async (newTag: string) => {
        if (!user) return;
        await updateMyInfo({ tags: [...user.tags, newTag] });
        setUser((prev: any) => ({ ...prev, tags: [...prev.tags, newTag] }));
    };

    const addTransformationType = async (newType: string) => {
        if (!user) return;
        const updated = [...(user.transformationTypes || []), newType];
        await updateMyInfo({ transformationTypes: updated });
        setUser((prev: any) => ({ ...prev, transformationTypes: updated }));
    };

    const addMemberType = async (newType: string) => {
        if (!user) return;
        const updated = [...(user.memberTypes || []), newType];
        await updateMyInfo({ memberTypes: updated });
        setUser((prev: any) => ({ ...prev, memberTypes: updated }));
    };

    const addClientTarget = async (newTarget: string) => {
        if (!user) return;
        const updated = [...(user.clientTargets || []), newTarget];
        await updateMyInfo({ clientTargets: updated });
        setUser((prev: any) => ({ ...prev, clientTargets: updated }));
    };

    const addClientSpecificity = async (newSpecificity: string) => {
        if (!user) return;
        const updated = [...(user.clientSpecificities || []), newSpecificity];
        await updateMyInfo({ clientSpecificities: updated });
        setUser((prev: any) => ({ ...prev, clientSpecificities: updated }));
    };

    const handleChange = (e: any) => {
        setNewCustomer((prevCustomer: any) => ({
            ...prevCustomer,
            [e.target.id]: e.target.value,
        }));
    };

    const addCustomer = async (redirectToList = true) => {

        const validationRules: any = {
            company: (value: any) => !!value.trim(),
        };

        if (isFormErrored(newCustomer, validationRules))
            return toast.error("Veuillez vérifier le formulaire");

        const res = await createCustomer(newCustomer);
        if (res) {
            toast.success("Prospect ajouté");
            redirectToList ? navigate("/kanban") : window.location.reload();
        }
    };

    // const handleChangeBilling = (e: any) => {
    //     setNewCustomer((prevCustomer: any) => ({
    //         ...prevCustomer,
    //         billingAddress: e.target.value,
    //         deliveryAddress: e.target.value,
    //     }));
    // };

	const createNewDeliveryTour = async (deliveryTour: any) => {
		const res = await createDeliveryTour(deliveryTour);
		if (res) {
			setDeliveryTours((prev: any) => [...prev, res]);
		}
		onClose();
	};

    const CreateDeliveryTour = (props: { isOpen: any; onClose: any }) => {
        const { isOpen, onClose } = props;
        const [newDeliveryTour, setNewDeliveryTour] = useState<any>({});

        return (
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay className="bg-[#000] !opacity-30" />
                <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]">
                    <ModalBody>
                        <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004]">
                            <h1 className="mb-[20px] text-2xl font-bold">
                                Rajouter une tournée de livraison
                            </h1>
                            <InputField
                                label="Nom de la tournée"
                                placeholder="Marseille-Est"
                                id="deliveryTour"
                                type="text"
                                onChange={(e: any) =>
                                    setNewDeliveryTour((prev: any) => ({
                                        ...prev,
                                        name: e.target.value,
                                    }))
                                }
                            />
                            <div className="mt-5 flex gap-2">
                                <button
                                    onClick={onClose}
                                    className="linear rounded-xl border-2 border-gray-700 px-5 py-3 text-base font-medium text-gray-700 transition duration-200 hover:bg-red-600/5 active:bg-red-700/5 dark:border-red-400 dark:bg-red-400/10 dark:text-white dark:hover:bg-red-300/10 dark:active:bg-red-200/10"
                                >
                                    Annuler
                                </button>
                                <button
                                    className="linear col-span-12 ml-3 flex items-center justify-center rounded-xl bg-[#0260CB] bg-[] px-3 py-3 text-base font-medium text-white hover:bg-[#01499b] active:bg-[#0260CB] sm:col-span-6 lg:col-span-4 xl:col-span-3 xl:col-start-12"
                                    onClick={() => {
										createNewDeliveryTour(
											newDeliveryTour
										);
										setNewDeliveryTour({});
									}}
                                >
                                    Créer la tournée
                                </button>
                            </div>
                        </Card>
                    </ModalBody>
                </ModalContent>
            </Modal>
        );
    };

	const initDeliveryTours = async () => {
		const res: any = await getDeliveryTours(false);
		if (res)
			setDeliveryTours(res.data);
	}

    useEffect(() => {
        // Set prospect status if it's in the URL
        const urlParams = new URLSearchParams(window.location.search);
        const status = urlParams.get("status");
        if (status) {
            setNewCustomer((prevCustomer: any) => ({
                ...prevCustomer,
                status,
            }));
        }

        if (localStorage.getItem("token") === null) {
            navigate("/login");
        }
		initDeliveryTours();
		initUser();
		initAcquisitionYears();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <GoBack />
            <div className="mt-3 grid  grid-cols-12">
                <CreateDeliveryTour isOpen={isOpen} onClose={onClose} />
                <div className={`col-span-12`}>
                    <Card extra={"w-full !p-5 border"}>
                        {/* Header */}
                        <div className="w-full">
                            <h4 className="text-lg font-medium text-navy-700 dark:text-white">
                                Ajout d'un prospect
                            </h4>
                        </div>
                        {/* inputs */}
                        <div className="mt-4 grid gap-3 grid-cols-12">
                            <p className="col-span-12 text-base">
                                Informations principales
                            </p>
                            <div className="col-span-12 lg:col-span-3">
                                <InputField
                                    label="Raison sociale*"
                                    placeholder="Toola"
                                    id="company"
                                    type="text"
                                    onChange={handleChange}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-2">
                                <InputField
                                    label="Numéro client"
                                    placeholder="00012"
                                    id="customerId"
                                    type="text"
                                    onChange={handleChange}
                                    error="Numéro de client invalide"
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-3">
                                <InputField
                                    label="Nom commercial"
                                    placeholder="Toola"
                                    id="displayName"
                                    type="text"
                                    onChange={handleChange}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-2">
                                <InputField
                                    label="Téléphone"
                                    placeholder="+33678003678"
                                    id="phone"
                                    type="text"
                                    onChange={handleChange}
                                    error="invalide"
                                    value={newCustomer.phone}
                                    isInvalid={
                                        !isValidPhoneNumber(newCustomer.phone)
                                    }
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-2">
                                <InputField
                                    label={`Contact`}
                                    placeholder="Mathieu Dupont"
                                    id="contact"
                                    type="text"
                                    onChange={handleChange}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-2">
                                <InputField
                                    label={`Poste du contact`}
                                    placeholder="Directeur achats"
                                    id="contactPoste"
                                    type="text"
                                    onChange={handleChange}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-2">
                                <InputField
                                    label={`Montant mensuel envisageable`}
                                    placeholder="500"
                                    id="potentialMonthlyRevenue"
                                    type="number"
                                    onChange={handleChange}
                                    value={newCustomer.potentialMonthlyRevenue}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-3 z-50">
                                <SearchSelector
                                    label="Type de transformation commerciale"
                                    displayKey="name"
                                    options={(user?.transformationTypes || []).map(
                                        (t: string) => ({ _id: t, name: t }),
                                    )}
                                    value={newCustomer.typeTransformation}
                                    onSelect={(e: any) =>
                                        setNewCustomer((prev: any) => ({
                                            ...prev,
                                            typeTransformation: e._id,
                                        }))
                                    }
                                    onCreateOption={addTransformationType}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-2 z-50">
                                <SearchSelector
                                    label="Année d'acquisition"
                                    displayKey="name"
                                    options={acquisitionYears.map((y: string) => ({ _id: y, name: y }))}
                                    value={newCustomer.anneeAcquisition}
                                    onSelect={(e: any) =>
                                        setNewCustomer((prev: any) => ({
                                            ...prev,
                                            anneeAcquisition: e._id,
                                        }))
                                    }
                                    onCreateOption={(newYear: string) =>
                                        setAcquisitionYears((prev) => [...prev, newYear])
                                    }
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-2 z-50">
                                <SearchSelector
                                    label="Type de membre"
                                    displayKey="name"
                                    options={(user?.memberTypes || []).map(
                                        (t: string) => ({ _id: t, name: t }),
                                    )}
                                    value={newCustomer.typeMembre}
                                    onSelect={(e: any) =>
                                        setNewCustomer((prev: any) => ({
                                            ...prev,
                                            typeMembre: e._id,
                                        }))
                                    }
                                    onCreateOption={addMemberType}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-3 z-50">
                                <SearchSelector
                                    label="Cible client"
                                    displayKey="name"
                                    options={(user?.clientTargets || []).map(
                                        (t: string) => ({ _id: t, name: t }),
                                    )}
                                    value={newCustomer.cibleClient}
                                    onSelect={(e: any) =>
                                        setNewCustomer((prev: any) => ({
                                            ...prev,
                                            cibleClient: e._id,
                                        }))
                                    }
                                    onCreateOption={addClientTarget}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-3 z-50">
                                <SearchSelector
                                    label="Spécificité client"
                                    displayKey="name"
                                    options={(user?.clientSpecificities || []).map(
                                        (t: string) => ({ _id: t, name: t }),
                                    )}
                                    value={newCustomer.specificiteClient}
                                    onSelect={(e: any) =>
                                        setNewCustomer((prev: any) => ({
                                            ...prev,
                                            specificiteClient: e._id,
                                        }))
                                    }
                                    onCreateOption={addClientSpecificity}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-5">
                                <InputField
                                    label={`Notes utiles`}
                                    placeholder="N'est pas disponible par téléphone le vendredi"
                                    id="notes"
                                    type="text"
                                    onChange={handleChange}
                                    inputSmall={true}
                                />
                            </div>
                            <div className="col-span-12 lg:col-span-3 z-50">
                                <InputTagField
                                    label="Tags clients"
                                    placeholder=""
                                    id="tags"
                                    type="text"
                                    extra=""
                                    tags={newCustomer.tags}
                                    allTags={
                                        user
                                            ? user.tags.map((name: string) => ({ name }))
                                            : []
                                    }
                                    onTagCreate={(tag: any) => addNewTag(tag)}
                                    onChange={(tags: any) =>
                                        setNewCustomer((prev: any) => ({
                                            ...prev,
                                            tags,
                                        }))
                                    }
                                />
                            </div>
                            <div className="mt-3 lg:mt-0 col-span-12 lg:col-span-3">
                                <label
                                    htmlFor={'sendNewsletter'}
                                    className={`text-xs font-medium text-navy-700 dark:text-white`}
                                >
                                    Envoi newsletter
                                </label>
                                <div className="mt-2 ml-2 flex">
                                    <Switch
                                        onChange={() => {
                                            setNewCustomer(
                                                (prevCustomer: any) => ({
                                                    ...prevCustomer,
                                                    sendNewsletter: !prevCustomer.sendNewsletter,
                                                }),
                                            );
                                        }}
                                        id={'sendNewsletter'}
                                        isDefaultChecked={newCustomer?.sendNewsletter}
                                        color="toola"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* full width inputs */}
                        <div className="mt-4 grid gap-3 grid-cols-12">
                            <div className="col-span-12">
                                <p className="text-base">Boutique B2B</p>
                                <p className="mt-1 text-xs">
                                    Permet à votre prospect de découvrir tout
                                    vos produits via un lien de connexion envoyé
                                    par email.
                                </p>
                            </div>
                            <div className="col-span-12 lg:col-span-4">
                                <InputField
                                    label="Email"
                                    placeholder="mathieu@toola.eu"
                                    id="mail"
                                    type="text"
                                    onChange={handleChange}
                                    error="Email invalide"
                                    value={newCustomer.mail}
                                    isInvalid={!isValidEmail(newCustomer?.mail)}
                                    inputSmall={true}
                                />
                            </div>
                        </div>

                        {/* <div className="mt-8 grid  grid-cols-1 gap-3 xl:grid-cols-12">
                        <p className="col-span-12 text-base">
                            Informations de livraison
                        </p>
                        <div className="col-span-12 lg:col-span-6">
                            <InputField
                                label="Adresse de livraison*"
                                placeholder={`Champ de Mars, 5 Av. Anatole France, 75007 Paris, France`}
                                id="deliveryAddress"
                                type="text"
                                onChange={handleChangeBilling}
                                inputSmall={true}
                            />
                        </div>
                        <div className="col-span-12 lg:col-span-3">
                            <SearchSelector
                                label="Tournée de livraison"
                                displayKey="name"
                                options={deliveryTours}
                                onSelect={(e: any) => {
                                    setNewCustomer((prevCustomer: any) => ({
                                        ...prevCustomer,
                                        deliveryTourId: e._id,
                                    }));
                                }}
                                canCreate={true}
                                createNew={onOpen}
                                inputSmall={true}
                            />
                        </div>
                    </div>
                    <div className="mt-8 grid  grid-cols-1 gap-3 xl:grid-cols-12">
                        <p className="col-span-12 text-base">
                            Informations de facturation
                        </p>
                        <div className="col-span-12 lg:col-span-3">
                            <InputField
                                label="Email de facturation*"
                                placeholder="mathieu@toola.eu"
                                id="billingEmail"
                                type="text"
                                onChange={handleChange}
                                error="Email invalide"
                                value={newCustomer.billingEmail}
                                isInvalid={
                                    !isValidEmail(newCustomer.billingEmail)
                                }
                                inputSmall={true}
                            />
                        </div>
                        <div className="col-span-12 lg:col-span-3">
                            <SearchSelector
                                label="Période de facturation*"
                                displayKey="name"
                                options={[
                                    { _id: "flexible", name: "flexible" },
                                    { _id: "7-days", name: "7 jours" },
                                    { _id: "10-days", name: "10 jours" },
                                    { _id: "15-days", name: "15 jours" },
                                    { _id: "1-month", name: "1 mois" },
                                ]}
                                onSelect={(e: any) => {
                                    setNewCustomer((prevCustomer: any) => ({
                                        ...prevCustomer,
                                        billingPeriod: e._id,
                                    }));
                                }}
                                inputSmall={true}
                            />
                        </div>
                        <div className="mt-4 col-span-12 lg:col-span-6 lg:mt-0">
                            <InputField
                                label={`Adresse de facturation*`}
                                placeholder="Champ de Mars, 5 Av. Anatole France, 75007 Paris, France"
                                value={newCustomer.billingAddress}
                                id="billingAddress"
                                type="text"
                                onChange={handleChange}
                                inputSmall={true}
                            />
                        </div>
                        <div className="col-span-12 lg:col-span-3">
                            <InputField
                                label={`Numéro de TVA`}
                                placeholder="FR32123456789"
                                id="vatNumber"
                                type="text"
                                onChange={handleChange}
                                error="Numéro de TVA invalide"
                                value={newCustomer.vatNumber}
                                isInvalid={
                                    !isValidVATNumber(newCustomer.vatNumber)
                                }
                                inputSmall={true}
                            />
                        </div>
                        <div className="col-span-12 lg:col-span-3">
                            <InputField
                                label={`Numéro de SIREN`}
                                placeholder="123568941"
                                id="siren"
                                type="text"
                                onChange={handleChange}
                                error="SIREN invalide"
                                value={newCustomer.siren}
                                isInvalid={!isValidSiren(newCustomer.siren)}
                                inputSmall={true}
                            />
                        </div>
                    </div> */}
                        <div className="mt-10 grid grid-cols-6 gap-5">
                            <button
                                className="linear col-span-3 flex items-center justify-center rounded-xl bg-[#0260CB] px-3 py-3 text-sm font-medium text-white hover:bg-[#01499b] active:bg-[#024086]"
                                onClick={() => addCustomer(false)}
                            >
                                Ajouter, puis en ajouter un autre
                            </button>
                            <button
                                className="linear col-span-3 flex items-center justify-center rounded-xl bg-[#0260CB] px-3 py-3 text-sm font-medium text-white hover:bg-[#01499b] active:bg-[#024086]"
                                onClick={() => addCustomer()}
                            >
                                Ajouter uniquement
                            </button>
                        </div>
                    </Card>
                </div>
            </div>
        </>
    );
};

export default CreateProspect;
